import {CreateDeliveryPointData} from "@app/core/delivery-point/application/dtos/create-delivery-point-data";


export class CreateDeliveryPointDataMapper {

    static serialize(param: CreateDeliveryPointData): any {
        return {
            code: param.code,
            tax: param.taxId,
            recaptchaToken: param.recaptchaToken,
        };
    }
}
